/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const HeaderDetectionResult = core.serialization.object({
    header: core.serialization.list(core.serialization.string()),
    headerRow: core.serialization.number(),
    letters: core.serialization.list(core.serialization.string()),
});
